import React, { useEffect, useState } from "react";
import { function_CON_Transferencias_Generar_JSON, function_CON_Transferencias_Insertar, function_CON_Transferencias_Leer } from "neftis7_apicaller/src/funciones/CONT/CON_Transferencias";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import ComboAbmConCuentasFinancieras from "../Compuestos/Combos/ComboAbmConCuentasFinancieras";
import LVConceptoObservaciones from "../Compuestos/Complejos/Operaciones/LVConceptoObservaciones";
import { DateBox, NumberBox, TextBox } from "devextreme-react";
import { Text } from "devextreme-react/linear-gauge";
import { function_ABM_CON_CuentasFinancieras_Leer } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_CuentasFinancieras";
import { function_ABM_CON_Monedas_Leer } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_Monedas";
import { FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";

const CON_TransferenciasCuentasFinancieras = (props) => {
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");

  const [loading, setLoading] = useState(true);
  const [fecha, setFecha] = useState(new Date());
  const [codigoCuentaFinancieraOrigen, setCodigoCuentaFinancieraOrigen] = useState("");
  const [cuentaFinancieraOrigen, setCuentaFinancieraOrigen] = useState("");
  const [codigoCuentaFinancieraDestino, setCodigoCuentaFinancieraDestino] = useState("");
  const [cuentaFinancieraDestino, setCuentaFinancieraDestino] = useState("");
  const [importeOrigen, setImporteOrigen] = useState(0);
  const [importeDestino, setImporteDestino] = useState(0);
  const [datosConceptoObservaciones, setDatosConceptoObservaciones] = useState([]);
  const [codigoMonedaOrigen, setCodigoMonedaOrigen] = useState("");
  const [cotizacionOrigen, setCotizacionOrigen] = useState(0);
  const [codigoMonedaDestino, setCodigoMonedaDestino] = useState("");
  const [cotizacionDestino, setCotizacionDestino] = useState(0);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const calcularImporteDestino = () => {
    if (cotizacionOrigen > 0 && cotizacionDestino > 0) {
      const nuevoImporteDestino = (importeOrigen * cotizacionOrigen) / cotizacionDestino;
      setImporteDestino(nuevoImporteDestino.toFixed(2));
    }
  };

  const handleOnClick_Guardar = async (e) => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);
      
      const JSON = await function_CON_Transferencias_Generar_JSON(FormateoFechaPara_yyyyMMdd_HHmmss(fecha),
        codigoCuentaFinancieraOrigen, codigoCuentaFinancieraDestino,
        "", "", 0, importeOrigen, importeDestino, datosConceptoObservaciones.concepto, datosConceptoObservaciones.observaciones, "", "", "",
        cotizacionOrigen, cotizacionDestino);

      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_CON_Transferencias_Insertar(JSON)

        alert("Se ha generado la Transferencia ID: " + Creado.data.codigoGenerado)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  }

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setLoading(true)
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")
          setLoading(false)
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  useEffect(() => {
    calcularImporteDestino();
  }, [importeOrigen, cotizacionOrigen, cotizacionDestino]);

  return (
    <>
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div>
          <div className="LV-GroupBox-div" style={{ marginBottom: '7px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>FECHA</span>
            <DateBox displayFormat="dd/MM/yyyy" value={fecha} onValueChanged={(e) => setFecha(e.value)} width={120} />
          </div>
          <div className="LV-GroupBox-div" style={{ marginBottom: '7px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>ORIGEN&nbsp;</span>
            <ComboAbmConCuentasFinancieras
              value={codigoCuentaFinancieraOrigen}
              IdTipoCuentaFinanciera={0}
              ancho="500"
              onValueChanged={async (e) => {
                setCodigoCuentaFinancieraOrigen(e.value);
                setCuentaFinancieraOrigen(e.component.option("text"));

                const resultCF = await function_ABM_CON_CuentasFinancieras_Leer(e.value)
                setCodigoMonedaOrigen(resultCF.data[0].CodigoMoneda)
                const resultMoneda = await function_ABM_CON_Monedas_Leer(resultCF.data[0].CodigoMoneda)

                setCotizacionOrigen(resultMoneda.data[0].Cotizacion)
              }} />
            MONEDA <TextBox value={codigoMonedaOrigen} readOnly={true} />
            COTIZACIÓN <NumberBox value={cotizacionOrigen}
              onValueChanged={(e) => setCotizacionOrigen(e.value)} />
            IMPORTE <NumberBox value={importeOrigen}
              onValueChanged={(e) => setImporteOrigen(e.value)} />
          </div>
          <div className="LV-GroupBox-div" style={{ marginBottom: '7px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>DESTINO</span>
            <ComboAbmConCuentasFinancieras
              value={codigoCuentaFinancieraDestino}
              IdTipoCuentaFinanciera={0}
              ancho="500"
              onValueChanged={async (e) => {
                setCodigoCuentaFinancieraDestino(e.value);
                setCuentaFinancieraDestino(e.component.option("text"));

                const resultCF = await function_ABM_CON_CuentasFinancieras_Leer(e.value)
                setCodigoMonedaDestino(resultCF.data[0].CodigoMoneda)
                const resultMoneda = await function_ABM_CON_Monedas_Leer(resultCF.data[0].CodigoMoneda)

                setCotizacionDestino(resultMoneda.data[0].Cotizacion)
              }} />
            MONEDA <TextBox value={codigoMonedaDestino} readOnly={true} />
            COTIZACIÓN <NumberBox value={cotizacionDestino}
              onValueChanged={(e) => setCotizacionDestino(e.value)} />
            IMPORTE <NumberBox value={importeDestino} readOnly={true}
              onValueChanged={(e) => setImporteDestino(e.value)} />
          </div>

          <LVConceptoObservaciones
            DatosConceptoObservaciones={datosConceptoObservaciones}
            setDatosConceptoObservaciones={setDatosConceptoObservaciones} />

          <div style={{ display: 'flex', marginBottom: '5px', marginTop: '20px', alignItems: 'center', justifyContent: 'center', gap: '50px' }}>
            <LVButtonAccion
              Disabled={cierreEnProceso} Texto={TituloBoton} onClick={handleOnClick_Guardar} />
          </div >
        </div >
      )}
    </>
  )
}

export default CON_TransferenciasCuentasFinancieras;